import { useQuery } from "react-query";
import inspectionTypeApi from "../utils/api/inspectionTypes";

export function useInspectionTypes() {
  return useQuery("inspectionTypes", () => inspectionTypeApi.index());
}

export function useInspectionTypesByTemplate(templateId: number | undefined, enabled: boolean = true) {
  return useQuery(
    ["inspectionTypes", "template", templateId],
    () => templateId ? inspectionTypeApi.getByTemplateId(templateId) : Promise.resolve([]),
    {
      enabled: !!templateId && enabled,
    }
  );
}